import userApi from '../../api/user.api';
import EventBus from '../../resources/eventBus';
import enginioText_EN from '../../assets/translations/EN.json';

const translationModules = import.meta.glob('../../assets/translations/*.json');

// initial state
const state = {
  user: {},
  favoriteOffers: [],
  favoriteGoodiebags: [],
  unlockedOffers: [],
  unlockedGoodiebags: [],
  activation: {},
  receipts: [],
  // currentGoodiebag: {},
  userStatus: '',
  userGdpr: {},
  surveyUpload: {},
  surveyFile: {},

  authenticated: false,
  username: localStorage.getItem('username'),

  fromRoute: null,

  transl: enginioText_EN,
  language: 'EN',

  loadedPageData: false,

  myProductsStatus: '',
  myProducts: [],
  myActivations: [],

  myReceiptsStatus: '',
  myReceipts: [],
  myCashbacksStatus: '',
  myCashbacks: [],

  clubPoints: 0,
};

// getters
const getters = {
  user: state => state.user,
  favoriteOffers: state => state.favoriteOffers,
  favoriteGoodiebags: state => state.favoriteGoodiebags,
  unlockedOffers: state => state.unlockedOffers,
  unlockedGoodiebags: state => state.unlockedGoodiebags,
  activation: state => state.activation,
  receipts: state => state.receipts,
  // currentGoodiebag: state => state.currentGoodiebag,
  userStatus: state => state.userStatus,
  userGdpr: state => state.userGdpr,
  surveyUpload: state => state.surveyUpload,
  surveyFile: state => state.surveyFile,

  authenticated: state => state.authenticated,
  username: state => state.username,

  fromRoute: state => state.fromRoute,

  transl: state => state.transl,
  language: state => state.language,

  loadedPageData: state => state.loadedPageData,
  myProducts: state => state.myProducts,
  myProductsStatus: state => state.myProductsStatus,
  myActivations: state => state.myActivations,

  myReceipts: state => state.myReceipts,
  myReceiptsStatus: state => state.myReceiptsStatus,
  myCashbacks: state => state.myCashbacks,
  myCashbacksStatus: state => state.myCashbacksStatus,

  clubPoints: state => state.clubPoints,
};

// actions
const actions = {
  async LOAD_TRANSL({ commit }, language) {
    const key = `../../assets/translations/${language}.json`;
    const loader = translationModules[key];
    if (!loader) {
      console.log(`[LOAD_TRANSL] No translations for language "${language}", falling back to EN.`);
      language = 'EN';
    }
    const module = await (translationModules[`../../assets/translations/${language}.json`])();
    commit('SET_TRANSL', { language, data: module.default });
  },

  // Consumer
  signupLoginUser({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.signupLoginUser(payload)
      .then((response) => {
        const { success, user } = response;
        // commit('SET_TRANSL', user.language);
        if (success) {
          commit('USER', user);
          commit('SET_USERNAME', user.name);
          commit('USER_STATUS', 'FINISHED');
          commit('SET_AUTHENTICATED', true);
        } else {
          commit('SET_AUTHENTICATED', false);
          commit('USER', {});
          commit('USER_STATUS', 'FINISHED');
          commit('SET_USERNAME', '');
        }
        return response;
      });
  },

  loginUser({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.loginUser(payload)
      .then((response) => {
        const { success, user } = response;
        // commit('SET_TRANSL', user.language);
        if (success) {
          commit('USER', user);
          commit('SET_USERNAME', user.name);
          commit('USER_STATUS', 'FINISHED');
          commit('SET_AUTHENTICATED', true);
        } else {
          commit('SET_AUTHENTICATED', false);
          commit('USER', {});
          commit('USER_STATUS', 'FINISHED');
          commit('SET_USERNAME', '');
        }
        return response;
      });
  },

  getUser({ commit, dispatch }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.getUser(payload)
      .then((response) => {
        const { success, user, language } = response;
        dispatch('LOAD_TRANSL', language);
        if (success) {
          commit('USER', user);
          commit('SET_USERNAME', user.name);
          commit('USER_STATUS', 'FINISHED');
          commit('SET_AUTHENTICATED', true);
        } else {
          commit('SET_AUTHENTICATED', false);
          commit('USER', {});
          commit('USER_STATUS', 'FINISHED');
          commit('SET_USERNAME', '');
        }
        return response;
      });
  },

  getUserInteractions({ commit }, payload) {
    return userApi.getUserInteractions(payload)
      .then((response) => {
        const { unlockedGoodiebags, unlockedOffers, favoriteOffers, favoriteGoodiebags } = response;
        commit('FAVORITE_OFFERS', favoriteOffers);
        commit('FAVORITE_GOODIEBAGS', favoriteGoodiebags);
        commit('UNLOCKED_OFFERS', unlockedOffers);
        commit('UNLOCKED_GOODIEBAGS', unlockedGoodiebags);
        return true;
      });
  },

  getUserClubPoints({ commit }, payload) {
    return userApi.getUserClubPoints(payload.companyId)
      .then((response) => {
        const { points_total, user } = response;
        commit('USER', user);
        commit('CLUB_POINTS', points_total);
        return points_total;
      });
  },

  getNarPV({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.getNarPV(payload.pvId)
      .then((response) => {
        commit('ACTIVATION', response.activation);
        commit('COMPANY', response.activation.enginioCompany);
        commit('USER_STATUS', 'FINISHED');
        return true;
      })
      .catch(() => {
        return false
      });
  },

  getMyProducts({ commit }, payload) {
    commit('MYPRODUCTS_STATUS', 'LOADING');
    return userApi.getMyProducts(payload.companyId)
    .then((response) => {
      commit('MYPRODUCTS', response.receipts);
      commit('MYACTIVATIONS', response.activations);
      commit('MYPRODUCTS_STATUS', 'FINISHED');
      return { products: response.receipts, activations: response.activations };
    });
  },

  getMyReceipts({ commit }) {
    commit('MYRECEIPTS_STATUS', 'LOADING');
    return userApi.getMyReceipts()
    .then((response) => {
      commit('MYRECEIPTS', response.receipts);
      commit('MYRECEIPTS_STATUS', 'FINISHED');
      return response.receipts;
    });
  },

  getMyCashbacks({ commit }) {
    commit('MYCASHBACKS_STATUS', 'LOADING');
    return userApi.getMyCashbacks()
    .then((response) => {
      commit('MYCASHBACKS', response.cashbacks);
      commit('MYCASHBACKS_STATUS', 'FINISHED');
      return response.cashbacks;
    });
  },

  getUserActivation({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.getUserActivation(payload)
      .then((response) => {
        commit('ACTIVATION', response.activation);
        commit('COMPANY', response.activation.enginioCompany);
        commit('USER_STATUS', 'FINISHED');
        return { success: true };
      })
      .catch((err) => {
        const { error, message } = err?.response?.data || {};
        return { success: false, error, message };
      });
  },

  getUserReceipts({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.getUserReceipts(payload)
      .then((response) => {
        commit('RECEIPTS', response.receipts);
        commit('USER_STATUS', 'FINISHED');
        const { canAddReceipt, locked, reason } = response;
        return { canAddReceipt, success: true, locked, reason };
      })
      .catch((err) => {
        const { error, message } = err.response.data;
        return { success: false, error, message };
      });
  },

  saveUserReceiptMetadata({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.saveUserReceiptMetadata(payload)
      .then((response) => {
        commit('ACTIVATION', response.activation);
        commit('USER_STATUS', 'FINISHED');
        return true;
      });
  },

  saveUserReceiptPicture({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.saveUserReceiptPicture(payload)
      .then((response) => {
        commit('ACTIVATION', response.activation);
        commit('USER_STATUS', 'FINISHED');
        return true;
      });
  },

  addUserGoodiebag({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.addUserGoodiebag(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
        return true;
      })
      .catch(() => {
        commit('USER_STATUS', 'FINISHED');
        commit('SET_AUTHENTICATED', false);
        return false;
      });
  },

  setFavoriteOffer({ commit }, payload) {
    return userApi.setFavoriteOffer(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
        console.log('setFavoriteOffer payload', payload);
        commit('SET_OFFER_FAVORITE', payload);
        return true;
      })
      .catch(() => {
        commit('USER_STATUS', 'FINISHED');
        return false;
      });
  },

  addUserSurveyOfferMedia({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_SURVEY_UPLOAD', payload);
      return resolve();
    });
  },

  addUserSurveyActivationMedia({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_SURVEY_UPLOAD', payload);
      return resolve();
    });
  },

  activateOffer({ commit }, payload) {
    return userApi.activateOffer(payload)
      .then((response) => {
        // The response is the bare User document, without fields like accepted_merchandises/accepted_subscriptions
        // that GET /users adds - replacing the user would make App.vue prompt the mandatory terms again
        commit('USER', { ...state.user, ...response.user });
        commit('USER_STATUS', 'FINISHED');
        return {
          interleaved_code: response.interleaved_code,
          ean_link: response.ean_link,
          winner_adress: response.winner_adress,
          cta_email: response.cta_email,
          no_cta: response.no_cta,
          success: response.success,
        };
      });
  },

  userSurveyUpload({ commit }) {
    return userApi.userSurveyUpload(state.surveyUpload)
      .then((response) => {
        commit('SET_SURVEY_UPLOAD', {});
        commit('USER_STATUS', 'FINISHED');
        return;
      });
  },

  userActivationSurveyUpload({ commit }) {
    // console.log('userActivationSurveyUpload', state.surveyUpload);
    return userApi.userActivationSurveyUpload(state.surveyUpload)
      .then((response) => {
        commit('RECEIPTS', [response.receipt]);
        commit('SET_SURVEY_UPLOAD', {});
        commit('USER_STATUS', 'FINISHED');
        return;
      });
  },

  activateHomeOffer({ commit }, payload) {
    return userApi.activateHomeOffer(payload)
      .then((response) => {
        commit('USER_STATUS', 'FINISHED');
        return { message: response.message };
      });
  },

  donateOffer({ commit }, payload) {
    return userApi.donateOffer(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
        return true;
      });
  },

  changeUser({ commit }, payload) {
    return userApi.changeUser(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
        return true;
      })
      .catch(() => {
        commit('USER_STATUS', 'FINISHED');
        return false;
      });
  },

  changeEmail({ commit }, payload) {
    return userApi.changeEmail(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
        return true;
      })
      .catch(() => {
        commit('USER_STATUS', 'FINISHED');
        return false;
      });
  },

  deleteUserDevice({ commit, rootState }, payload) {
    return userApi.deleteUserDevice(payload)
    .then((response) => {
      const user = response.user;
      let logOut = true;
      for (let index = 0; index < user.devices.length; index++) {
        const device = user.devices[index];
        if (rootState.device.deviceId === device.visitor_id) {
          logOut = false;
        }
      }
      if (logOut) {
        return EventBus.emit('logout');
      }
      commit('USER', user);
      commit('USER_STATUS', 'FINISHED');
      return { message: response.message };
    });
  },

  subscribeEmail({ commit }) {
    return userApi.subscribeEmail()
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
        return response.message;
      })
      .catch(() => {
        commit('USER_STATUS', 'FINISHED');
        return false;
      });
  },

  subscribeCompany({ commit }, payload) {
    return userApi.subscribeCompany(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
        return response.message;
      })
      .catch(() => {
        commit('USER_STATUS', 'FINISHED');
        return false;
      });
  },

  acceptOfferTerms({ commit }, payload) {
    return userApi.acceptOfferTerms(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
        return response.message;
      })
      .catch(() => {
        commit('USER_STATUS', 'FINISHED');
        return false;
      });
  },

  deleteUser({ commit }) {
    commit('USER_STATUS', 'LOADING');
    return userApi.deleteUser()
      .then(() => {
        commit('SET_AUTHENTICATED', false);
        commit('USER', {});
        commit('USER_STATUS', 'FINISHED');
        commit('SET_USERNAME', '');
        return;
      });
  },

  setAuthenticated({ commit }, authenticated) {
    commit('SET_AUTHENTICATED', authenticated);
  },

  setUsername({ commit }, username) {
    commit('SET_USERNAME', username);
  },

  setFromRoute({ commit }, fromRoute) {
    commit('SET_FROM_ROUTE', fromRoute);
  },

  setLoadedPageData({ commit }, loadedPageData) {
    commit('SET_LOADED_PAGE_DATA', loadedPageData);
  },

  logoutFeUser({commit}) {
    commit('SET_AUTHENTICATED', false);
    commit('USER', {});
    commit('USER_STATUS', 'FINISHED');
    commit('SET_USERNAME', '');
    return true;
  },

  logoutUser({ commit }) {
    commit('USER_STATUS', 'LOADING');
    return userApi.logoutUser()
      .then(() => {
        commit('SET_AUTHENTICATED', false);
        commit('USER', {});
        commit('USER_STATUS', 'FINISHED');
        commit('SET_USERNAME', '');
        return true;
      })
      .catch(() => {
        return false;
      });
  },

  resetActivation({ commit }) {
    commit('ACTIVATION', {});
  },

  // Admin
  bookmarkAdminGoodiebag({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.bookmarkAdminGoodiebag(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
      });
  },

  bookmarkAdminOffer({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.bookmarkAdminOffer(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
      });
  },

  // Company
  bookmarkCompanyGoodiebag({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.bookmarkCompanyGoodiebag(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
      });
  },

  bookmarkCompanyOffer({ commit }, payload) {
    commit('USER_STATUS', 'LOADING');
    return userApi.bookmarkCompanyOffer(payload)
      .then((response) => {
        commit('USER', response.user);
        commit('USER_STATUS', 'FINISHED');
      });
  },
};

// mutations
const mutations = {
  USER(state, user) {
    let localUser = user;
    localUser.organizedDevices = groupBy(user.devices, 'device_type');
    state.user = localUser;
  },
  ACTIVATION(state, activation) {
    state.activation = activation;
  },
  RECEIPTS(state, receipts) {
    state.receipts = receipts;
  },
  /*
  SET_CURRENT_GOODIEBAG(state, goodiebagId) {
    for (let i = 0; i < state.user.favorite_goodiebags.length; i += 1) {
      if (state.user.favorite_goodiebags[i]._id.toString() === goodiebagId) {
        state.currentGoodiebag = state.user.favorite_goodiebags[i];
      }
    }
  },
  */
  USER_STATUS(state, status) {
    state.userStatus = status;
  },
  SET_AUTHENTICATED(state, authenticated) {
    state.authenticated = authenticated;
  },
  SET_USERNAME(state, username) {
    let shortUsername = username;
    if (username) {
      shortUsername = username.split(' ')[0].substring(0, 8);
      localStorage.setItem('username', shortUsername);
    }
    state.username = shortUsername;
  },
  FAVORITE_OFFERS(state, favoriteOffers) {
    state.favoriteOffers = favoriteOffers;
  },
  FAVORITE_GOODIEBAGS(state, favoriteGoodiebags) {
    state.favoriteGoodiebags = favoriteGoodiebags;
  },
  UNLOCKED_OFFERS(state, unlockedOffers) {
    state.unlockedOffers = unlockedOffers;
  },
  UNLOCKED_GOODIEBAGS(state, unlockedGoodiebags) {
    state.unlockedGoodiebags = unlockedGoodiebags;
  },
  SET_SURVEY_UPLOAD(state, payload) {
    const surveyFile = payload.surveyFile;
    const surveyUpload = {...payload};
    if (surveyUpload.surveyFile) {
      delete surveyUpload.surveyFile;
    }

    state.surveyUpload =  surveyUpload;
    state.surveyFile =  surveyFile;
  },

  SET_FROM_ROUTE(state, fromRoute) {
    state.fromRoute = fromRoute;
  },

  SET_TRANSL(state, { language, data }) {
    console.log(`[SET_TRANSL] Setting language to: ${language}`);
    state.language = language;
    state.transl = data;
    EventBus.emit('CHANGED_TRANSL');
  },

  SET_LOADED_PAGE_DATA(state, loadedPageData) {
    state.loadedPageData = loadedPageData;
  },
  MYPRODUCTS_STATUS(state, status){
    state.myProductsStatus = status;
  },
  MYPRODUCTS(state, receipts) {
    state.myProducts = receipts;
  },
  MYACTIVATIONS(state, activations) {
    state.myActivations = activations;
  },
  MYRECEIPTS_STATUS(state, status) {
    state.myReceiptsStatus = status;
  },
  MYRECEIPTS(state, receipts) {
    state.myReceipts = receipts;
  },
  MYCASHBACKS_STATUS(state, status) {
    state.myCashbacksStatus = status;
  },
  MYCASHBACKS(state, cashbacks) {
    state.myCashbacks = cashbacks;
  },
  CLUB_POINTS(state, points) {
    state.clubPoints = points;
  },
};

function groupBy(objectArray, property) {
  if (objectArray) {
    return objectArray.reduce(function (acc, obj) {
      let key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  } else {
    return {};
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
};
